import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/base_images/placeholder.svg'


const _withScopeId = n => (_pushScopeId("data-v-b51b692a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 2,
  src: _imports_0,
  alt: "Image Placeholder"
}

import { useGameStore } from '@/stores/gameStore';
import { useUserStore } from '@/stores/userStore';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneratedImage',
  props: {
  generatedImage: String
},
  setup(__props) {



const gameStore = useGameStore();

const userStore = useUserStore();

const won = computed(
  () => userStore.currentRound?.survived && gameStore.scored
);

const lost = computed(
  () => !userStore.currentRound?.survived && gameStore.scored
);

return (_ctx: any,_cache: any) => {
  return (__props.generatedImage)
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: __props.generatedImage,
        alt: "Generated\n    Image",
        class: _normalizeClass({
      image: true,
      '--win': won.value,
      '--lose': lost.value
    })
      }, null, 10, _hoisted_1))
    : (_unref(gameStore).loadingImage && !__props.generatedImage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass({
      'generated-image__container': true,
      '--loading': _unref(gameStore).loadingImage && !__props.generatedImage,
      '--win': won.value,
      '--lose': lost.value
    })
        }, [
          _createElementVNode("img", {
            src: require('@/assets/paint-roll.svg'),
            alt: "Painting...",
            class: "loading-image"
          }, null, 8, _hoisted_2)
        ], 2))
      : (_openBlock(), _createElementBlock("img", _hoisted_3))
}
}

})